export const filterDataTable = (dataTable, filters) => {
    return dataTable.filter(item => {
        return Object.keys(filters).every(key => {
            const filterValue = filters[key];
            if (filterValue === null || filterValue === undefined) {
                return true;
            }

            if (key === "kodeVariant" && item.variant) {
                return filterValue.includes(item.variant.kodeVariant);
            }

            if (key === "kodeWarna" && item.warna) {
                return filterValue.includes(item.warna.id);
            }

            if (key === "startPeriod" || key === "endPeriod") {
                const factureDate = new Date(item.factureDate.split("-").reverse().join("-"));
                if (key === "startPeriod") {
                    const startDate = new Date(filterValue.split("-").reverse().join("-"));
                    return factureDate >= startDate;
                }
                if (key === "endPeriod") {
                    const endDate = new Date(filterValue.split("-").reverse().join("-"));
                    return factureDate <= endDate;
                }
            }

            if (typeof filterValue === "string") {
                return item[key]?.toLowerCase().includes(filterValue.toLowerCase());
            }

            return item[key] === filterValue;
        });
    });
}